"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDirectInsertClassDetailsArray = exports.isDirectInsertMultiConcentrationLimitLpSlugRecordArray = exports.isDirectInsertConcentrationLimitRecordArray = exports.isDirectInsertEligibilityTestRecordArray = exports.isDirectInsertBorrowingBaseReportLpSlugRecordArray = exports.isReceivableWaiverTestKeyStringsArray = exports.isReceivableWaiverTestKeyStrings = void 0;
const BorrowingBase_1 = require("../types/BorrowingBase");
const CreditFacility_1 = require("../types/CreditFacility");
const typeguardUtils_1 = require("./typeguardUtils");
exports.isReceivableWaiverTestKeyStrings = (0, typeguardUtils_1.zodTypeGuard)(BorrowingBase_1.ReceivableWaiverTestKeyStringsSchema);
exports.isReceivableWaiverTestKeyStringsArray = (0, typeguardUtils_1.zodArrayTypeGuard)(BorrowingBase_1.ReceivableWaiverTestKeyStringsSchema);
exports.isDirectInsertBorrowingBaseReportLpSlugRecordArray = (0, typeguardUtils_1.zodTypeguardArrayFunctionLogWrapper)({
    schema: BorrowingBase_1.DirectInsertBorrowingBaseReportLpSlugRecordSchema,
    typeguardName: 'isDirectInsertBorrowingBaseReportLpSlugRecord',
});
exports.isDirectInsertEligibilityTestRecordArray = (0, typeguardUtils_1.zodTypeguardArrayFunctionLogWrapper)({
    schema: BorrowingBase_1.DirectInsertEligibilityTestRecordSchema,
    typeguardName: 'isDirectInsertEligibilityTestRecord',
});
exports.isDirectInsertConcentrationLimitRecordArray = (0, typeguardUtils_1.zodTypeguardArrayFunctionLogWrapper)({
    schema: BorrowingBase_1.DirectInsertConcentrationLimitRecordSchema,
    typeguardName: 'isDirectInsertConcentrationLimitRecord',
});
exports.isDirectInsertMultiConcentrationLimitLpSlugRecordArray = (0, typeguardUtils_1.zodTypeguardArrayFunctionLogWrapper)({
    schema: BorrowingBase_1.DirectInsertMultiConcentrationLimitLpSlugRecordSchema,
    typeguardName: 'isDirectInsertMultiConcentrationLimitLpSlugRecord',
});
exports.isDirectInsertClassDetailsArray = (0, typeguardUtils_1.zodTypeguardArrayFunctionLogWrapper)({
    schema: CreditFacility_1.DirectInsertClassDetailsSchema,
    typeguardName: 'isDirectInsertClassDetails',
});
//# sourceMappingURL=borrowingBase.js.map